import { readCookie, writePersistentCookie } from "common/utils/cookie";

export const get = flag => readCookie(flag);
export const isOn = flag => Boolean(get(flag));
export const isOff = flag => !isOn(flag);

export const set = (flag, value) => writePersistentCookie(flag, value);
export const toggle = flag => set(flag, new Date());
